import type { LeadMagnetSubmitPayload } from "../../core/api-client.js";
import type { IfiFormModel } from "./ui-state.js";

export function mapIfiFormToSubmitPayload(form: IfiFormModel): LeadMagnetSubmitPayload {
  const isFrance = isFranceCountry(form.country);
  const residencePrincipale = parseOptionalNumber(form.residencePrincipale);
  const autresBiens = parseOptionalNumber(form.autresBiens);
  const actifsFromFrance =
    residencePrincipale !== undefined && autresBiens !== undefined
      ? residencePrincipale * 0.7 + autresBiens
      : undefined;
  const actifs = isFrance ? actifsFromFrance : parseOptionalNumber(form.actifs);
  const passifs = parseOptionalNumber(form.passifs);

  return {
    email: form.email.trim(),
    firstName: form.firstName.trim() || undefined,
    source: form.source.trim(),
    consent: true,
    honeypot: form.honeypot,
    country: form.country.trim() || undefined,
    answers: {
      actifs,
      passifs
    }
  };
}

function parseOptionalNumber(value: string): number | undefined {
  const normalized = value.trim().replaceAll(/\s+/g, "");
  if (!normalized) {
    return undefined;
  }
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function isFranceCountry(value: string): boolean {
  const normalized = value.trim().toUpperCase();
  return normalized === "FR" || normalized === "FRANCE";
}
